import { ModuleFE_User } from './ModuleFE_User.js';
export const ModulePackFE_UserDB = [ModuleFE_User];
//# sourceMappingURL=module-pack.js.map